<template>
  <div class="py-4 container-fluid">
    <!-- 全局筛选器 -->
    <div class="card mb-3">
      <div class="card-body d-flex flex-wrap align-items-center justify-content-between py-3">
        <div class="d-flex align-items-center flex-wrap gap-2">
          <span class="text-sm font-weight-bold me-2">时间段</span>
          <!-- 快捷按钮 -->
          <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn" :class="days === 0 && quickBtn === 'today' ? 'btn-primary' : 'btn-outline-primary'" @click="setQuickRange('today')">今日</button>
            <button type="button" class="btn" :class="days === 0 && quickBtn === 'yesterday' ? 'btn-primary' : 'btn-outline-primary'" @click="setQuickRange('yesterday')">昨日</button>
            <button type="button" class="btn" :class="days === 7 ? 'btn-primary' : 'btn-outline-primary'" @click="setDays(7)">近7天</button>
            <button type="button" class="btn" :class="days === 30 ? 'btn-primary' : 'btn-outline-primary'" @click="setDays(30)">近30天</button>
            <button type="button" class="btn" :class="days === 90 ? 'btn-primary' : 'btn-outline-primary'" @click="setDays(90)">近90天</button>
            <button type="button" class="btn" :class="days === 183 ? 'btn-primary' : 'btn-outline-primary'" @click="setDays(183)">半年</button>
            <button type="button" class="btn" :class="days === 365 ? 'btn-primary' : 'btn-outline-primary'" @click="setDays(365)">一年</button>
          </div>
          <!-- 自定义日期范围 -->
          <span class="text-xs text-secondary ms-2 me-1">自定义</span>
          <input type="date" v-model="customStart" @change="onCustomRange" class="form-control form-control-sm" style="width:140px" />
          <span class="text-xs text-secondary">~</span>
          <input type="date" v-model="customEnd" @change="onCustomRange" class="form-control form-control-sm" style="width:140px" />
          <span v-if="dateRangeText" class="text-xs text-secondary ms-2">{{ dateRangeText }}</span>
        </div>
        <div class="d-flex align-items-center flex-wrap gap-2">
          <span class="text-sm font-weight-bold me-2">商户下钻</span>
          <input
            v-model="deliverIdInput"
            type="number"
            placeholder="输入商户ID（可选）"
            class="form-control form-control-sm"
            style="width:160px"
            @keyup.enter="onFilterChange"
          />
          <button class="btn btn-sm btn-primary" @click="onFilterChange">
            <i class="fas fa-search"></i> 确认
          </button>
          <button v-if="deliverId" class="btn btn-sm btn-outline-secondary" @click="clearDeliverFilter">
            <i class="ni ni-fat-remove"></i> 清除
          </button>
        </div>
      </div>
    </div>

    <!-- Tab 导航 -->
    <ul class="nav nav-tabs mb-3" id="statisticTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link" :class="{ active: activeTab === 'overview' }" @click="activeTab = 'overview'">
          <i class="ni ni-chart-bar-32 me-1"></i>平台总览
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" :class="{ active: activeTab === 'merchant' }" @click="activeTab = 'merchant'">
          <i class="ni ni-shop me-1"></i>商户分析
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" :class="{ active: activeTab === 'device' }" @click="activeTab = 'device'">
          <i class="ni ni-sound-wave me-1"></i>设备分析
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" :class="{ active: activeTab === 'health' }" @click="activeTab = 'health'">
          <i class="ni ni-health me-1"></i>运营相关
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" :class="{ active: activeTab === 'points' }" @click="activeTab = 'points'">
          <i class="ni ni-credit-card me-1"></i>积分报表
        </button>
      </li>
    </ul>

    <!-- Tab 内容 -->
    <div class="tab-content">
      <div v-show="activeTab === 'overview'">
        <PlatformOverview :days="days" :deliverId="deliverId" :startDate="startDate" :endDate="endDate" :key="'ov-' + filterKey" />
      </div>
      <div v-show="activeTab === 'merchant'">
        <MerchantAnalysis :days="days" :deliverId="deliverId" :startDate="startDate" :endDate="endDate" :key="'ma-' + filterKey" />
      </div>
      <div v-show="activeTab === 'device'">
        <DeviceAnalysis :days="days" :deliverId="deliverId" :startDate="startDate" :endDate="endDate" :key="'da-' + filterKey" />
      </div>
      <div v-show="activeTab === 'health'">
        <OperationsHealth :days="days" :deliverId="deliverId" :startDate="startDate" :endDate="endDate" :key="'oh-' + filterKey" />
      </div>
      <div v-show="activeTab === 'points'">
        <PointsReport :deliverId="deliverId" :startDate="startDate" :endDate="endDate" :key="'pr-' + filterKey" />
      </div>
    </div>
  </div>
</template>

<script>
import PlatformOverview from "./PlatformOverview.vue";
import MerchantAnalysis from "./MerchantAnalysis.vue";
import DeviceAnalysis from "./DeviceAnalysis.vue";
import OperationsHealth from "./OperationsHealth.vue";
import PointsReport from "./PointsReport.vue";

export default {
  name: "Statistic",
  components: {
    PlatformOverview,
    MerchantAnalysis,
    DeviceAnalysis,
    OperationsHealth,
    PointsReport,
  },
  data() {
    return {
      activeTab: "overview",
      days: 30,
      quickBtn: "",
      customStart: "",
      customEnd: "",
      deliverIdInput: "",
      deliverId: 0,
      filterKey: 0,
      customStartDate: 0,
      customEndDate: 0,
    };
  },
  computed: {
    startDate() {
      if (this.customStartDate > 0) return this.customStartDate;
      const now = Math.floor(Date.now() / 1000);
      return now - this.days * 86400;
    },
    endDate() {
      if (this.customEndDate > 0) return this.customEndDate;
      return Math.floor(Date.now() / 1000);
    },
    dateRangeText() {
      const s = new Date(this.startDate * 1000);
      const e = new Date(this.endDate * 1000);
      const fmt = (d) => `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}`;
      return `${fmt(s)} ~ ${fmt(e)}`;
    },
  },
  methods: {
    setDays(d) {
      this.days = d;
      this.quickBtn = "";
      this.customStart = "";
      this.customEnd = "";
      this.customStartDate = 0;
      this.customEndDate = 0;
      this.filterKey++;
    },
    setQuickRange(type) {
      this.days = 0;
      this.quickBtn = type;
      this.customStart = "";
      this.customEnd = "";
      const now = new Date();
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime() / 1000;
      const todayEnd = todayStart + 86400 - 1;
      if (type === "today") {
        this.customStartDate = todayStart;
        this.customEndDate = todayEnd;
      } else if (type === "yesterday") {
        this.customStartDate = todayStart - 86400;
        this.customEndDate = todayStart - 1;
      }
      this.filterKey++;
    },
    onCustomRange() {
      if (!this.customStart || !this.customEnd) return;
      const s = new Date(this.customStart + "T00:00:00+08:00").getTime() / 1000;
      const e = new Date(this.customEnd + "T23:59:59+08:00").getTime() / 1000;
      if (s >= e) return;
      this.days = 0;
      this.quickBtn = "";
      this.customStartDate = s;
      this.customEndDate = e;
      this.filterKey++;
    },
    onFilterChange() {
      this.deliverId = this.deliverIdInput ? parseInt(this.deliverIdInput) : 0;
      this.filterKey++;
    },
    clearDeliverFilter() {
      this.deliverIdInput = "";
      this.deliverId = 0;
      this.filterKey++;
    },
  },
};
</script>
